import { Paginated, request } from "utils/api";

// root groups schema
export interface RootGroup {
    groupName: string,
    id: string,
    numMembers: number,
    inviteDay?: number,
    notifyDaysBeforeStartDate?: number,
}

// fetch root groups (GET /root/groups)
export const getRootGroups = (data: {
    limit?: number,
    offset?: number,
    query?: string,
}) => request<Paginated<RootGroup>>({
    data,
    endpoint: "/root/groups",
    method: "get",
});

export interface AddGroups {
    groupId?: string,
    notifyDaysBeforeStartDate?: number,
}

// edit root groups of booking (PATCH /root/bookings/groups)
export const patchRootBookingGroups = (data: {
    addGroups: AddGroups[],
    applyToFutureInSeries?: boolean,
    bookingId: string,
    removeGroupIds?: string[],
}) => request<Paginated<RootGroup>>({
    data,
    endpoint: "/root/bookings/groups",
    method: "patch",
});

// fetch root groups of booking (GET /root/bookings/groups)
export const getRootBookingGroups = (data: {
    bookingId: string,
}) => request<Paginated<RootGroup>>({
    data,
    endpoint: "/root/bookings/groups",
    method: "get",
});
